





















































































































































import { SvgImage } from '@/app/components';
import { useSockets } from '@/app/composable/socket';
import { StatusCode } from '@/modules/asset/constants';
import {
    ArchiveIcon,
    QuestionMarkCircleIcon,
    FolderAddIcon,
    FireIcon,
    HomeIcon,
    SearchIcon,
    ServerIcon,
    ShareIcon,
    ClipboardListIcon,
    TemplateIcon,
    FolderOpenIcon,
    XIcon,
    CloudDownloadIcon,
} from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';
import { useFeatureFlags } from '../composable';

export default defineComponent({
    name: 'SideMenu',
    components: {
        HomeIcon,
        FolderAddIcon,
        FolderOpenIcon,
        SearchIcon,
        ShareIcon,
        TemplateIcon,
        XIcon,
        SvgImage,
        ClipboardListIcon,
        QuestionMarkCircleIcon,
        FireIcon,
        ArchiveIcon,
        ServerIcon,
        CloudDownloadIcon,
    },
    props: {
        mobileMenuOpen: { type: Boolean, default: false },
    },
    setup() {
        const { isEnabled: isFeatureEnabled, areAnyEnabled: areAnyFeaturesEnabled } = useFeatureFlags();
        const { connected, socketConnect } = useSockets();
        const defaultAssetStatus = Object.values(StatusCode).filter(
            (statusCode: StatusCode) => ![StatusCode.Deleted, StatusCode.Archived].includes(statusCode),
        );
        const sidebarNavigation = computed(() => [
            { name: 'Home', route: 'dashboard', icon: HomeIcon, exact: true, visible: true },
            {
                name: 'Data Collection Pipeline Creation',
                route: 'data-checkin-jobs',
                icon: FolderAddIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'My Data Assets',
                route: 'assets',
                query: { status: defaultAssetStatus.join(','), reset: true },
                icon: FolderOpenIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'Data Repository',
                route: 'data-repository',
                icon: ArchiveIcon,
                exact: true,
                visible: isFeatureEnabled('sharing'),
            },
            {
                name: 'Contracts Log',
                route: 'contracts',
                icon: ClipboardListIcon,
                exact: true,
                visible: isFeatureEnabled('sharing'),
            },
            {
                name: 'Retrieval Requests',
                route: 'retrieval',
                icon: CloudDownloadIcon,
                exact: false,
                visible: areAnyFeaturesEnabled(['retrieve.api', 'retrieve.files', 'retrieve.stream']),
            },
            {
                name: 'FAQ',
                route: 'faq',
                icon: QuestionMarkCircleIcon,
                exact: true,
                visible: true,
            },
        ]);

        return { sidebarNavigation, connected, socketConnect, areAnyFeaturesEnabled };
    },
});
